import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from "ant-design-vue"
import 'ant-design-vue/dist/antd.css';
import './assets/js/dragdialog'
// 引入全局混入方法
import mixin from './mixin';

Vue.use(Antd);
Vue.mixin(mixin)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
